<template>
  <div>
    <h3 class="header-pegaso">Selezione tratta</h3>
    <p>Selezionare i due estremi della tratta extra-urbana di interesse per visualizzare le tariffe.</p>
    <b-row>
      <!-- componente per la selezione della località che emette un evento quando la località di partenza viene scelta -->
      <SelectPlace :isStart="true" @comune-selected="comuneFromSelected" @localita-selected="localitaFromSelected" />
    </b-row>
    <b-row>
      <!-- componente per la selezione della località che emette un evento quando la località di destinazione viene scelta -->
      <SelectPlace :isStart="false" @comune-selected="comuneToSelected" @localita-selected="localitaToSelected" />
    </b-row>
    <div class="spinner-container">
      <b-spinner label="Spinning" v-if="loading"></b-spinner>
    </div>
    <div class="result-wrapper">
      <div class="rates-table-container" v-for="table in tables" :key="table.id">
        <h3 class="header-pegaso">Tratta {{ table.id }}</h3>
        <p class="slot">(Fascia km: {{ table.slot }})</p>
        <table class="tariffe-table">
          <thead>
            <tr>
              <th rowspan="2">Abbonamento</th>
              <th rowspan="2" v-if="table.hasDaily">Giornaliero</th>
              <th colspan="2" class="center">Mensile</th>
              <th colspan="2" class="center">Annuale</th>
            </tr>
            <tr>
              <th>Intero</th>
              <th>Ridotto*</th>
              <th>Intero</th>
              <th>Ridotto*</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in table.rows" :key="row.title">
              <td>{{ row.title }}</td>
              <td class="price" v-if="table.hasDaily">{{ row.dailyPrice }}</td>
              <td class="price">{{ row.montlyPrice }}</td>
              <td class="price">{{ row.montlyPriceIsee }}</td>
              <td class="price">{{ row.yerlyPrice }}</td>
              <td class="price">{{ row.yearlyPriceIsee }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="note" v-if="tablesLoaded">
        * La tariffa ridotta si applica alla classe di reddito familiare equivalente ISEE fino a 36.151,98 euro
        per gli utenti residenti in Toscana ed in possesso del tagliando ISEE TPL. Per informazioni sul tagliando ISEE TPL 
        consultare <a href="https://www.regione.toscana.it/abbonamenti-ed-agevolazioni-isee" target="_blank">https://www.regione.toscana.it/abbonamenti-ed-agevolazioni-isee</a>.
      </p>
    </div>
    
    <b-alert variant="warning" :show="showNoResultMessage" class="mt-5">
      Tariffa Pegaso non disponibile per la tratta selezionata.
    </b-alert>

  </div>
</template>

<script>
import SelectPlace from './SelectPlace.vue';
import { buildLegTables } from '@/utils/tariffe-utils';
import * as config from '@/utils/config';

export default {
  name: "FormTariffe",
  components: {
    SelectPlace,
  },
  data() {
    return {
      comuneFrom: null,
      comuneTo: null,
      localitaFrom: null,
      localitaTo: null,
      tables: null,
      showNoResultMessage: false,
      loading: false
    };
  },
  computed: {
    tablesLoaded() {
      return this.tables !== null && this.tables.length > 0;
    }
  },
  methods: {
    comuneFromSelected(comuneFrom) {
      this.comuneFrom = comuneFrom;
       if (this.comuneFrom === null) {
        this.showNoResultMessage = false;
      }
    },
    comuneToSelected(comuneTo) {
      this.comuneTo = comuneTo;
      if (this.comuneTo === null) {
        this.showNoResultMessage = false;
      }
    },
    localitaFromSelected(localitaFrom) {
      this.localitaFrom = localitaFrom;
      if (this.localitaFrom) {
        this.loadTariffe();
      } else {
        this.tables = null;
      }
    },
    localitaToSelected(localitaTo) {
      this.localitaTo = localitaTo;
      if (this.localitaTo) {
        this.loadTariffe();
      } else {
        this.tables = null;
      }
    },
    loadTariffe() {
      if (!this.localitaFrom || !this.localitaTo) {
        this.tables = null;
        return;
      }
      let url = config.API_BASE_URL + '/oggetto/cerca?';
      url += 'comDa=' + this.comuneFrom;
      url += '&locDa=' + this.localitaFrom;
      url += '&comA=' + this.comuneTo;
      url += '&locA=' + this.localitaTo;

      const options = {
        headers: {
          Accept: 'application/json',
        }
      }
      this.loading = true;
      this.$http.get(url, options)
      .then((response) => {
        const ratesObject = response.body.item;
        let rates = response.body.item.tratte;
        if (rates !== null && rates !== undefined) {
          ratesObject.tratte = Array.isArray(rates) ? rates : [rates];
        }

        if (ratesObject.tratte !== null
            && ratesObject.tratte !== undefined
            && ratesObject.tratte.length > 0) {
          this.tables = buildLegTables(ratesObject);
          this.showNoResultMessage = false;
        } else {
          this.tables = null;
          this.showNoResultMessage = true;
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error('ERRORE', error);
        alert('Errore nel recupero delle tariffe: ' + error.message);
      });
    }
  },
};
</script>

<style lang="scss">

.tariffe {
  margin-top: 4em;
}

.rates-table-container {
  margin-top: 0;
}

.tariffe-table {
  width: 100%;
  background-color: white;
  border-collapse: collapse;
  border: solid 1px #DEDEDE;
  margin-bottom: 5em;

  td, th {
    padding: 1em;
    border-bottom: solid 1px #DEDEDE;
    border-top: solid 1px #DEDEDE;
    border-left: dotted 1px #DEDEDE;
    border-right: dotted 1px #DEDEDE;

    &.price {
      white-space: nowrap;
    }
  }

  th {
    color: #555;
    background-color: #E2E2E2;
    border-bottom: solid 1px #BCBCBC;
    border-top: solid 1px #BCBCBC;
    border-left: dotted 1px #BCBCBC;
    border-right: dotted 1px #BCBCBC;

    &.center {
      text-align: center;
    }
  }
}

.note {
  font-size: 0.9em;
  margin-left: 0.5em;
  margin-bottom: 5em;
}

.spinner-container {
  margin: 1em 0;
  text-align: center;
  min-height: 3em;
}

</style>